import { render, staticRenderFns } from "./verify-email.vue?vue&type=template&id=6888aad0&scoped=true&"
import script from "./verify-email.vue?vue&type=script&lang=js&"
export * from "./verify-email.vue?vue&type=script&lang=js&"
import style0 from "./verify-email.vue?vue&type=style&index=0&id=6888aad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6888aad0",
  null
  
)

component.options.__file = "verify-email.vue"
export default component.exports